import { PageManager } from '@mvps-genesis/core';
import ringSizer from 'Extensions/ring-sizer';

export default class RingSize extends PageManager {

	constructor( pageContext ) {

		super( pageContext );

	}

	onReady() {

		const self = this;

		ringSizer();
	}

}
